module.exports = __webpack_public_path__ + "static/img/share_bg_1.8b8071e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share_bg_1.png
// module id = n6Qh
// module chunks = 1